// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.card {
     /* border: 3px solid red; */
    width: 500px;
    height: 300px;
    color: #fff;
    cursor: pointer;
    perspective: 1000px;
    border: 0 !important;
    margin-top: 30px;
}

.card-inner {
    width: 90%;
    height: 100%;
    position: relative;
    transition: transform 1s;
    transform-style: preserve-3d;
}


.front{
    width: 100%;
    height: 300px;
    /* background-image: linear-gradient(45deg, #0045c7, #ff2c7d); */
    position: absolute;
    top: 0;  
    left: 0;
    padding: 20px 30px;
    border-radius: 15px;
    overflow: hidden;
    z-index: 1;
    backface-visibility: hidden;
}


/* GiftCardComponent.css */


@media print {
    body {
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background-color: #fff !important;
    }

    .color-white {
        color: #fff !important; /* Force the text color to be white */ 
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
   

    body * {
        visibility: hidden; /* Hide all element s */
    }

    #gift-code p {
        margin-top: 45px !important;
        margin-left: -100px !important;
    }

    .card {
        width: 500px; 
        height: 300px;
        color: #fff;
        cursor: pointer;
        perspective: 1000px;
        border: 0 !important;
        margin-top: 30px;
    }
    .card-inner{
        width: 100% !important;
    }
    #gift-card, #gift-card * {
        visibility: visible; 
    }
    .slick-slide {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    #gift-card {
        position: relative;
        left: 0; 
        top: 0;
        /* width: 300px; */
        margin: 0 auto;
   
    }

    /* Forcing all text in the gift card to white */
    #gift-card p, #gift-card h5, #gift-card span, #gift-card div {
        color: #fff !important;
    }
}



  
  /* Add any additional styles for the card here */
  .card {
    width: 500px; /* Adjust card width */
    height: 300px; /* Adjust card height */
    color: #fff; /* Text color */
    cursor: pointer;
    perspective: 1000px;
    border: 0 !important;
    margin-top: 30px;
  }
  
.logo-3d{
    width: 140px;
    margin-top: -20px;
}
.card-no p{
    color: #fff;
}
.card-holder p{
    color: #fff;
}
.name p{
    color: #fff;
    /* margin-top: 10px; */
}
.card-no p {
    letter-spacing: 3px; /* Adjust as needed */
  }
.map-img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    /* opacity: 0.15; */
    z-index: -1;
    height: 100%;
    object-fit: cover;
}

/* .card-no {
    font-size: 35px;
    margin-top: 30px;
} */

.card-holder {
    font-size: 12px;
    margin-top: 20px;
}
#gift-code  p {
    color: #fff;
    margin-top: 5px;
    font-size: 30px;
}

.name {
    font-size: 26px;
}

.card-cvv {
    margin-top: 20px;
}

.card-cvv div {
    flex: 1 1;
}

.card-cvv img {
    width: 100%;
    display: block;
    line-height: 0;
}

.card-cvv p {
    background: #fff;
    color: #000;
    font-size: 22px;
    padding: 10px 20px;
}

.card-text {
    margin-top: 30px;
    font-size: 14px;
}

.signature {
    margin-top: 30px;
}
  .slick-prev:before{
    font-size: 50px;
    line-height: 1;
    opacity: .75;
    color: #2b2828;
}
  
.slick-next, .slick-prev {
    top:33% !important ;
}
.slick-next:before{
    font-size: 50px;
    line-height: 1;
    opacity: .75;
    color: #2b2828;
}
  .slick-next{
right: 17px
  }
  .slick-prev {
left: -2px;
z-index: 100; 
 }

  @media (max-width: 786px) {
    .custom-arrow {
      display: none; /* Hide the arrow */
    }
    .slick-arrow ,.slick-next{
        display: none !important;
     }
     .card-inner {
        width: 100%;
        height: 100%;
        position: relative;
        transition: transform 1s;
        transform-style: preserve-3d;
    }
  }

  
@media screen and (min-width: 200px) and (max-width: 768px) {
    .card {
            width: 100%;
        }
        .logo-3d{
            width: 100px;
        }
        .card-no p{
            color: #fff;
            font-size: 20px;
        }
        .logo-3d{
            width: 140px;
            margin-top: -20px;
        }
        .front{
            padding: 20px 10px;
        }
        #gift-code p{
            font-size: 30px;
        }
}`, "",{"version":3,"sources":["webpack://./src/pages/gift-success/style.css"],"names":[],"mappings":";AACA;KACK,2BAA2B;IAC5B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,4BAA4B;AAChC;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,gEAAgE;IAChE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;;AAGA,0BAA0B;;;AAG1B;IACI;QACI,SAAS;QACT,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,sBAAsB,EAAE,qCAAqC;QAC7D,iCAAiC;QACjC,yBAAyB;IAC7B;;;IAGA;QACI,kBAAkB,EAAE,uBAAuB;IAC/C;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,oBAAoB;QACpB,gBAAgB;IACpB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;MACrB;IACF;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,kBAAkB;QAClB,cAAc;;IAElB;;IAEA,+CAA+C;IAC/C;QACI,sBAAsB;IAC1B;AACJ;;;;;EAKE,gDAAgD;EAChD;IACE,YAAY,EAAE,sBAAsB;IACpC,aAAa,EAAE,uBAAuB;IACtC,WAAW,EAAE,eAAe;IAC5B,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;AAEF;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,mBAAmB,EAAE,qBAAqB;EAC5C;AACF;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;EACE;IACE,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;EACE;AACF;EACE;EACA;AACF,UAAU;AACV,YAAY;CACX;;EAEC;IACE;MACE,aAAa,EAAE,mBAAmB;IACpC;IACA;QACI,wBAAwB;KAC3B;KACA;QACG,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,wBAAwB;QACxB,4BAA4B;IAChC;EACF;;;AAGF;IACI;YACQ,WAAW;QACf;QACA;YACI,YAAY;QAChB;QACA;YACI,WAAW;YACX,eAAe;QACnB;QACA;YACI,YAAY;YACZ,iBAAiB;QACrB;QACA;YACI,kBAAkB;QACtB;QACA;YACI,eAAe;QACnB;AACR","sourcesContent":["\n.card {\n     /* border: 3px solid red; */\n    width: 500px;\n    height: 300px;\n    color: #fff;\n    cursor: pointer;\n    perspective: 1000px;\n    border: 0 !important;\n    margin-top: 30px;\n}\n\n.card-inner {\n    width: 90%;\n    height: 100%;\n    position: relative;\n    transition: transform 1s;\n    transform-style: preserve-3d;\n}\n\n\n.front{\n    width: 100%;\n    height: 300px;\n    /* background-image: linear-gradient(45deg, #0045c7, #ff2c7d); */\n    position: absolute;\n    top: 0;  \n    left: 0;\n    padding: 20px 30px;\n    border-radius: 15px;\n    overflow: hidden;\n    z-index: 1;\n    backface-visibility: hidden;\n}\n\n\n/* GiftCardComponent.css */\n\n\n@media print {\n    body {\n        margin: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100vh;\n        background-color: #fff !important;\n    }\n\n    .color-white {\n        color: #fff !important; /* Force the text color to be white */ \n        -webkit-print-color-adjust: exact;\n        print-color-adjust: exact;\n    }\n   \n\n    body * {\n        visibility: hidden; /* Hide all element s */\n    }\n\n    #gift-code p {\n        margin-top: 45px !important;\n        margin-left: -100px !important;\n    }\n\n    .card {\n        width: 500px; \n        height: 300px;\n        color: #fff;\n        cursor: pointer;\n        perspective: 1000px;\n        border: 0 !important;\n        margin-top: 30px;\n    }\n    .card-inner{\n        width: 100% !important;\n    }\n    #gift-card, #gift-card * {\n        visibility: visible; \n    }\n    .slick-slide {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    #gift-card {\n        position: relative;\n        left: 0; \n        top: 0;\n        /* width: 300px; */\n        margin: 0 auto;\n   \n    }\n\n    /* Forcing all text in the gift card to white */\n    #gift-card p, #gift-card h5, #gift-card span, #gift-card div {\n        color: #fff !important;\n    }\n}\n\n\n\n  \n  /* Add any additional styles for the card here */\n  .card {\n    width: 500px; /* Adjust card width */\n    height: 300px; /* Adjust card height */\n    color: #fff; /* Text color */\n    cursor: pointer;\n    perspective: 1000px;\n    border: 0 !important;\n    margin-top: 30px;\n  }\n  \n.logo-3d{\n    width: 140px;\n    margin-top: -20px;\n}\n.card-no p{\n    color: #fff;\n}\n.card-holder p{\n    color: #fff;\n}\n.name p{\n    color: #fff;\n    /* margin-top: 10px; */\n}\n.card-no p {\n    letter-spacing: 3px; /* Adjust as needed */\n  }\n.map-img {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    /* opacity: 0.15; */\n    z-index: -1;\n    height: 100%;\n    object-fit: cover;\n}\n\n/* .card-no {\n    font-size: 35px;\n    margin-top: 30px;\n} */\n\n.card-holder {\n    font-size: 12px;\n    margin-top: 20px;\n}\n#gift-code  p {\n    color: #fff;\n    margin-top: 5px;\n    font-size: 30px;\n}\n\n.name {\n    font-size: 26px;\n}\n\n.card-cvv {\n    margin-top: 20px;\n}\n\n.card-cvv div {\n    flex: 1;\n}\n\n.card-cvv img {\n    width: 100%;\n    display: block;\n    line-height: 0;\n}\n\n.card-cvv p {\n    background: #fff;\n    color: #000;\n    font-size: 22px;\n    padding: 10px 20px;\n}\n\n.card-text {\n    margin-top: 30px;\n    font-size: 14px;\n}\n\n.signature {\n    margin-top: 30px;\n}\n  .slick-prev:before{\n    font-size: 50px;\n    line-height: 1;\n    opacity: .75;\n    color: #2b2828;\n}\n  \n.slick-next, .slick-prev {\n    top:33% !important ;\n}\n.slick-next:before{\n    font-size: 50px;\n    line-height: 1;\n    opacity: .75;\n    color: #2b2828;\n}\n  .slick-next{\nright: 17px\n  }\n  .slick-prev {\nleft: -2px;\nz-index: 100; \n }\n\n  @media (max-width: 786px) {\n    .custom-arrow {\n      display: none; /* Hide the arrow */\n    }\n    .slick-arrow ,.slick-next{\n        display: none !important;\n     }\n     .card-inner {\n        width: 100%;\n        height: 100%;\n        position: relative;\n        transition: transform 1s;\n        transform-style: preserve-3d;\n    }\n  }\n\n  \n@media screen and (min-width: 200px) and (max-width: 768px) {\n    .card {\n            width: 100%;\n        }\n        .logo-3d{\n            width: 100px;\n        }\n        .card-no p{\n            color: #fff;\n            font-size: 20px;\n        }\n        .logo-3d{\n            width: 140px;\n            margin-top: -20px;\n        }\n        .front{\n            padding: 20px 10px;\n        }\n        #gift-code p{\n            font-size: 30px;\n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
